import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import type { User } from '~/http/user/User'

export class UserAPI extends Http {
  load = (): Promise<User> => {
    return this.callAuthAPI<null, User>(HttpMethod.GET, { path: APIPaths.USER }, null)
  }
}
